import React from "react";
import { Link } from "react-router-dom";
import { FaBagShopping } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";

import { FaBorderAll } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function Mywishlist() {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <main className="page-content">
        <div className="tm-section tm-my-account-area bg-white tm-padding-section profile-men wishlist-section-ones">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <div className="tm-myaccount tm-myaccount-fives">
                  <div className="my-profile-left">
                    <img src="assets/images/user-photo.png" />
                    <h2>{t("MO8")}</h2>
                    <p>+91 9999999999</p>
                  </div>
                  <ul className="nav tm-tabgroup tabgroup-left1">
                    <li className="nav-item">
                      <Link to="/Myprofile" className="nav-link ">
                        <FaBagShopping /> {t("MO1")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Myorder" className="nav-link ">
                        <FaBorderAll /> {t("MO14")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Myaddress" className="nav-link ">
                        <i className="fas fa-map-marker-alt me-2" />  {t("MO2")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Mywishlist" className="nav-link active ">
                        <FaHeart />  {t("W1")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Login" className="nav-link ">
                        <LuLogOut />  {t("MO4")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-9 col-md-8">
                <div className="my-profile-right">
                  <div className="tm-wishlist-1">
                    <div className="my-wishlist">
                      <h4>
                      {t("W1")}<span>  {t("W2")}</span>
                      </h4>
                    </div>
                    <div className="wishlist-menbox">
                      <div className="row">
                        <div className="col-lg-3 col-md-6 col-6">
                          <div className="wishlist-one">
                            <button className="tm-wishlist-removeproduct remove-btn remove-btn-two">
                              <i className="ion-close" />
                            </button>
                            <img src="assets/images/brandlogo-wlist.png" />
                            <div className="wishlist-texts">
                              <h2> {t("C3")}</h2>
                              <div className="itemdetails-itemPricing">
                                <span className="itemdetails-boldFont">
                                  Rs.2,519
                                </span>
                                <span className="itemdetails-strike">
                                  Rs.5,599
                                </span>
                                <span className="itemdetails-discountPercent">
                                  ( {t("W6")})
                                </span>
                              </div>
                              <a className="moveBag-btn" href="#">
                              {t("W3")}
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-6">
                          <div className="wishlist-one">
                            <button className="tm-wishlist-removeproduct remove-btn remove-btn-two">
                              <i className="ion-close" />
                            </button>
                            <img src="assets/images/brandlogo-wlist1.png" />
                            <div className="wishlist-texts">
                            <h2> {t("C3")}</h2>
                              <div className="itemdetails-itemPricing">
                                <span className="itemdetails-boldFont">
                                  Rs.2,519
                                </span>
                                <span className="itemdetails-strike">
                                  Rs.5,599
                                </span>
                                <span className="itemdetails-discountPercent">
                                  ( {t("W6")})
                                </span>
                              </div>
                              <a className="moveBag-btn" href="#">
                              {t("W3")}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Mywishlist;
